import Transform from "@ember-data/serializer/transform";
import Protocol from "core/models/protocol";
export default class ProtocolsTransform extends Transform {
  deserialize(serialized) {
    return serialized?.map(protocol => Protocol.new(protocol));
  }
  serialize(deserialized) {
    return deserialized;
  }
}